/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EodMelcoEodModelsMachineDesign,
    EodMelcoEodModelsMachineDesignFromJSON,
    EodMelcoEodModelsMachineDesignToJSON,
    EodMelcoEodModelsMachineProdRequest,
    EodMelcoEodModelsMachineProdRequestFromJSON,
    EodMelcoEodModelsMachineProdRequestToJSON,
    EodMelcoEodModelsMachineProdResponse,
    EodMelcoEodModelsMachineProdResponseFromJSON,
    EodMelcoEodModelsMachineProdResponseToJSON,
    EodMelcoModelsBoolResponse,
    EodMelcoModelsBoolResponseFromJSON,
    EodMelcoModelsBoolResponseToJSON,
    EodMelcoModelsError,
    EodMelcoModelsErrorFromJSON,
    EodMelcoModelsErrorToJSON,
} from '../models';

export interface MachineJobsApiEodMachineScanRequest {
    eodMelcoEodModelsMachineProdRequest?: EodMelcoEodModelsMachineProdRequest;
}

export interface MachineJobsApiEodMachineTrackRequest {
    eodMelcoEodModelsMachineDesign?: EodMelcoEodModelsMachineDesign;
}

/**
 * 
 */
export class MachineJobsApi extends runtime.BaseAPI {

    /**
     */
    async eodMachineScanRaw(requestParameters: MachineJobsApiEodMachineScanRequest): Promise<runtime.ApiResponse<EodMelcoEodModelsMachineProdResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/eod/machine/scan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EodMelcoEodModelsMachineProdRequestToJSON(requestParameters.eodMelcoEodModelsMachineProdRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoEodModelsMachineProdResponseFromJSON(jsonValue));
    }

    /**
     */
    async eodMachineScan(requestParameters: MachineJobsApiEodMachineScanRequest): Promise<EodMelcoEodModelsMachineProdResponse> {
        const response = await this.eodMachineScanRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eodMachineTrackRaw(requestParameters: MachineJobsApiEodMachineTrackRequest): Promise<runtime.ApiResponse<EodMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/eod/machine/scan/track`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EodMelcoEodModelsMachineDesignToJSON(requestParameters.eodMelcoEodModelsMachineDesign),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async eodMachineTrack(requestParameters: MachineJobsApiEodMachineTrackRequest): Promise<EodMelcoModelsBoolResponse> {
        const response = await this.eodMachineTrackRaw(requestParameters);
        return await response.value();
    }

}
